import { React, useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../joylogo.png';
import Icon from '@mdi/react';
import Search from './search';

function Bottombar(props){


  const [menu,setMenu] = useState(false);
  const [search,setSearch] = useState(false);
  const [sresult, setSresult] = useState("")

  const menuhandler = () =>{

    if(menu === false){
          setMenu(true)
          //console.log(menu)
          setSearch(false)
  }else{
      setMenu(false)
  }
  }


  const searchhandler = (e) =>{

    if(search === false){
    setSearch(true)
    //setMenu(false)
    }
    else{
   // setSearch(false)
    }
    setSresult(e.target.value)
  }

    return(
<div className="row show-mobile" >
    {/* <div className={search? "showm container": "hidem"}>
        <form style={{height: "100vh"}}>

            <input type="text" placeholder="search..." style={{marginTop:"20px", width:"100%", border: "1px solid #cccccc", borderRadius: "10px", padding: "5px"}}/>
        </form>

    </div> */}

<div className={menu? "showm" : "hidem"}>
<form style={{}}>

<div style={{}}>
    <input type="text" placeholder="type something..." style={{marginTop:"20px", width:"100%", border: "none", padding: "0px 0px 0px 5px"}} onChange={searchhandler}/>
</div>

{<Search search={ sresult } hideshow={ search } />}
{/* <div style={{}}><a  onClick={()=>(true)} style={{background:  "#ff0000", padding: "11px 15px 11px 15px", color:"#ffffff", marginTop:"20px", display:"block"}}><i className="fas fa-archive"></i></a>
</div> */}
</form>
    <header>
       
        <nav className="navbar" style={{}}>
        <ul className="navbar-nav" style={{width:"100%"}}>
            <li className="nav-item">
                <a href="/politics" className={menu === "politics"?"activelink":""}>
            <i className="fas fa-gavel"></i>Politics
             </a>
            </li>
           
            
            <li className="nav-item">
                <a href="/business" className={menu === "business"?"activelink":""}>
            <i className="far fa-building"></i>Business
            </a>
            </li>
            
            
            <li className="nav-item">
                <a href="/entertainment" className={menu === "entertainment"?"activelink":""}>
               <i className="far fa-smile"></i>Entertainment
               </a>
            </li>
            
            
         
            <li className="nav-item">
                <a href="/sports" className={menu === "sports"?"activelink":""}>
            <i className="fas fa-futbol"></i>Sports
             </a>
            </li>
           
            
            <li className="nav-item">
                <a href="/health" className={menu === "health"?"activelink":""}>
            <i className="fas fa-briefcase-medical"></i>Health
            </a>
            </li>
           

            <li className="nav-item">
                <a href="/technology" className={menu === "technology"?"activelink":""}>
                    <i class="fas fa-code-branch"></i>Technology
            </a>
            </li>

            
            <li className="nav-item">
                <a href="/opinion" className={menu === "opinion"?"activelink":""}>
                    <i className="fas fa-paint-brush"></i>Opinion
            </a>
            </li>
            
            
            <li className="nav-item">
                <a href="/lifestyle" className={menu === "lifestyle"?"activelink":""}>
                <i className="fas fa-suitcase"></i>Lifestyle
            </a></li>
       
            <li className="nav-item">
                <a href="/gallery" className={menu === "gallery"?"activelink":""}>
                <i className="fa fa-picture-o" aria-hidden="true"></i>Gallery
            </a></li>

            <li className="nav-item">
                <a href="/obituary" className={menu === "obituary"?"activelink":""}>
                <i className='fas fa-cross'></i>Obituary
            </a></li>
            {/* <li className="nav-item">
                <a href="/" className={menu === "archives"?"activelink":""}>
                <i className="fas fa-archive"></i>Archives
            </a></li> */}
        </ul>
        
        </nav>
        </header>
    </div>


  <div className="container bottombar">
    
   
     {/* <Link to="/"><i className="fa-solid fa-house"></i><br />Home</Link>
     <Link to="#" onClick={searchhandler}><i className="fas fa-search"></i><br /> Search</Link>
     <Link to="#" onClick={menuhandler}><i className="fas fa-bars"></i><br/>Menu</Link> */}
     <a  onClick={menuhandler} style={{position: "fixed", bottom: "10px", right: "10px", borderRadius: "200%", background:  "#ff0000", padding: "11px 16px 11px 16px", color:"#ffffff"}}><i className="fas fa-bars"></i></a>

     </div>
  </div>


        
    )
}

export default Bottombar;